module.exports = __webpack_public_path__ + "static/img/y2.1e370c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/y2.png
// module id = WcHa
// module chunks = 1